import { cn } from "@/utils/cn";
import { FC } from "react";

export const CloseBadgeIcon: FC<{ className?: string }> = ({ className }) => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
		<path d="M3.5 3.5L8.5 8.5M8.5 3.5L3.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export const CloseBadgeIcon2: FC<{ className?: string }> = ({ className }) => (
	<span
		className={cn(
			"inline-flex items-center justify-center rounded-full bg-white text-gray-500 border border-gray-300",
			"hover:bg-primary-100 hover:text-primary-600 transition-colors duration-150 w-3 h-3 text-xs font-bold shadow",
			className,
		)}
		style={{ lineHeight: 1 }}
	>
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.5 3.5L8.5 8.5M8.5 3.5L3.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	</span>
);
